import { ConsentDocument } from '../types/consents';

// We don't have version 4 as it was a temporary version for Black companies before release
export const EU_COMPANY_AGREEMENTS: Readonly<ConsentDocument[]> = [
  {
    link: '/legal/Treyd_Terms_and_Conditions_Payment_Service_v1.pdf',
    title: 'Account agreement',
    version: 1,
  },
  {
    link: '/legal/Treyd_Terms_and_Conditions_Payment_Service_v2.pdf',
    title: 'Account agreement',
    version: 2,
  },
  {
    link: '/legal/General_Services_Agreement_EU.pdf',
    title: 'General services agreement',
    version: 3,
  },
  {
    link: '/legal/General_Services_Agreement.pdf',
    title: 'General services agreement',
    version: 5,
  },
];

export const UK_COMPANY_AGREEMENTS: Readonly<ConsentDocument[]> = [
  {
    link: '/legal/General_Services_Agreement_UK.pdf',
    title: 'General service agreement',
    version: 3,
  },
  {
    link: '/legal/General_Services_Agreement.pdf',
    title: 'General service agreement',
    version: 5,
  },
];

export const TOS: Readonly<ConsentDocument> = {
  link: '/legal/Platform_Terms_And_Conditions.pdf',
  title: 'Terms of services',
};
